import classes from "./form-elements.module.css";

interface XListFormProps {
    children: React.ReactNode[];
    header: string;
    maxRows: number;
    rows: number;
    onChange?: (e: any) => void;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
}

export const XListForm = ({
    children,
    header,
    rows,
    onChange,
    onFocus,
    onBlur,
}: XListFormProps) => (
    <fieldset
        className={classes.xListFieldset}
        data-pw="dg-list-form"
        onFocus={onFocus}
        onBlur={onBlur}
    >
        <label className={classes.xListHeader}>
            <span>{header}</span>
            <input
                type="text"
                className={classes.xListHeaderInput}
                value={rows}
                onChange={(e) =>
                    onChange?.({target: {value: e.target.value}})
                }
            />
        </label>
        <div className={classes.xListChildren}>{children}</div>
    </fieldset>
);
